import React, { useContext } from 'react';
import { getPath } from '@express-labs/raven-tools';
import LogInState from './LogInState';
import { HeaderDynamicContext } from '../../../../../../contexts/HeaderDynamicData/HeaderDynamicData';

function LogInStateVM(props) {
  const { customer } = useContext(HeaderDynamicContext);
  const flagNewTiers = getPath(window, 'FLAGS.NewTiers', false);
  return <LogInState data={customer} flagNewTiers={flagNewTiers} {...props} />;
}

export default LogInStateVM;
